<template>
  <div>
    <TextField v-if="settings.type === 'string' || settings.type === 'number'" :settings="settings" :value="value" @input="$emit('input', $event)" />
    <DatePicker v-else-if="settings.type === 'date'" :value="value" @input="$emit('input', $event)" />
    <ArrayControl v-else-if="canShowArray" :value="value" :settings="settings" @input="$emit('input', $event)" />
  </div>
</template>
<script>
import TextField from './TextField.vue';
import DatePicker from './DatePicker.vue';
import ArrayControl from './ArrayControl.vue';

export default {
  components: {
    TextField,
    DatePicker,
    ArrayControl
  },
  props: {
    value: {
      type: [String, Number, Object],
      default: ''
    },
    settings: {
      type: Object,
      default: () => ({})
    },
    operator: {
      type: String,
      default: ''
    }
  },
  computed: {
    canShowArray() {
      return this.settings.type === 'array' && ['contains', 'does not contain'].includes(this.operator);
    }
  }
};
</script>
